import styled from "styled-components";

export const HistoricalPerformanceChartContainer = styled.div`
  position: relative;
  height: 100%;

  .investment-value {
    .total {
      .amount {
        margin-bottom: 0.6rem;
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_28};
        color: ${({ theme }) => theme.heading.color.secondary};
      }

      .extra-info {
        line-height: 1;
        margin-bottom: 0.6rem;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
      }
    }

    .date {
      font-size: 12px;
      margin-left: 5px;
    }
  }

  @media (max-width: 820px) {
    .investment-value {
      .total {
        flex-direction: column;
        font-size: 24px;
        line-height: 1;
      }

      .gain {
        font-size: 12px;
      }
    }

    .recharts-surface {
      margin-top: 6rem;
    }

    .h-performance-filter {
      margin-top: 6rem;
    }
  }
`;

export const LegendContainer = styled.ul`
  background: ${({ theme }) => theme.button.bg.secondary};
  border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  padding: 10px 0;

  li {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .line {
    border-radius: 10px;
    width: 15px;
    height: 2px;
    display: inline-block;
    margin-right: 6px;
  }

  .name {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    opacity: ${({ theme }) => theme.chart.legend.opacity};
    font-weight: 500;
    font-size: 10px;
  }

  .value {
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
    font-size: 14px;
  }

  .date {
    font-size: 12px;
    margin-left: 5px;
  }

  @media (max-width: 820px) {
    .gain {
      font-size: 12px;
    }
  }
`;
